import { FaEnvelope, FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa";
import styled from "styled-components";
import { ReactComponent as PaymentAccept } from "../../assets/icons/banka.svg";

export const FooterBottom = styled.div`
  text-align: center;
  padding-top: 40px;
  border-top: 1px solid var(--accent-light);
  color: var(--text-muted);
  font-size: 14px;
`;

export const FooterContainer = styled.footer`
  background: var(--surface);
  padding: 80px 0 40px;
  border-top: 2px solid var(--accent-light);

  @media (max-width: 768px) {
    padding: 40px 0 40px;
  }
`;

export const ContactInfo = styled.p`
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 15px;
  cursor: pointer;
  padding: 0 !important;

  div {
    width: 50px;
    height: 50px;
    background: var(--secondary);
    border: 2px solid var(--accent-light);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    font-size: 16px;

    &:hover {
      background: var(--accent);
      border-color: var(--accent);
      transform: translateY(-5px);
      color: var(--surface);
    }
  }
  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

export const SocialLinkInsta = styled(FaInstagram)`
  width: 45px;
  height: 45px;
  padding: 0.855rem;
  background: var(--secondary);
  border: 2px solid var(--accent-light);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  font-size: 16px;
  color: var(--accent);

  &:hover {
    background: var(--accent);
    border-color: var(--accent);
    transform: translateY(-5px);
    color: var(--surface);
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    padding: 0.72rem;
  }
`;

export const SocialLinkTiktok = styled(FaTiktok)`
  width: 45px;
  height: 45px;
  padding: 0.9rem;

  background: var(--secondary);
  border: 2px solid var(--accent-light);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  font-size: 16px;
  color: var(--accent);

  &:hover {
    background: var(--accent);
    border-color: var(--accent);
    transform: translateY(-5px);
    color: var(--surface);
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    padding: 0.8rem;
  }
`;

export const SocialLinkEmail = styled(FaEnvelope)`
  width: 45px;
  height: 45px;
  padding: 0.9rem;

  background: var(--secondary);
  border: 2px solid var(--accent-light);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  font-size: 16px;
  color: var(--accent);

  &:hover {
    background: var(--accent);
    border-color: var(--accent);
    transform: translateY(-5px);
    color: var(--surface);
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    padding: 0.8rem;
  }
`;

export const SocialLinkYt = styled(FaYoutube)`
  width: 50px;
  height: 50px;
  padding: 1rem;

  background: var(--secondary);
  border: 2px solid var(--accent-light);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  font-size: 16px;
  color: var(--accent);

  &:hover {
    background: var(--accent);
    border-color: var(--accent);
    transform: translateY(-5px);
    color: var(--surface);
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    padding: 0.72rem;
  }
`;

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  height: 100%;
`;

export const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 30px;
  margin-bottom: 50px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 25px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    gap: 20px;
    margin-bottom: 40px;
  }
`;
export const Logo = styled.img`
  max-height: 50px;
  margin-bottom: 19px;

  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`;
export const FooterSection = styled.div`
  h4 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 15px;
    text-transform: uppercase;
    color: var(--accent);
    display: flex;
    align-items: center;
    gap: 10px;
  }

  p {
    color: var(--text-secondary);
    margin-bottom: 20px;
  }

  div {
    color: var(--text-secondary);
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 0;
    transition: color 0.3s ease;
    font-size: 14px;

    &:hover {
      color: var(--accent);
    }
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    p {
      margin-bottom: 0;
    }
    div {
      padding: 4px 0;
    }
    h4 {
      margin-bottom: 10px;
    }
  }
`;

export const PaymentAcceptIcon = styled(PaymentAccept)`
  height: 30px;
  margin-left: -5px;

  @media (max-width: 768px) {
    margin-left: 0px;
  }
`;
